import type { GridSortModel } from "@mui/x-data-grid-pro";
import type { ReceptionBookOrdering, ReceptionBookSortKey } from "../types";

/** 受付帳の既定の並び（受付日の新しい順） */
export const DEFAULT_RECEPTION_BOOK_ORDERING: ReceptionBookOrdering =
  "-reception_date";

/** 受付帳の表の列（field）と、BE の並び替え項目の対応。ここに無い列は並び替えできない */
export const RECEPTION_BOOK_SORT_KEYS: Readonly<
  Record<string, ReceptionBookSortKey>
> = {
  legalAffairsBureauRequestDate: "reception_date",
  legalAffairsBureauReceptionNumber: "reception_number",
  commercialRequesterTypeName: "requester_type",
};

/**
 * 表の並び替えの状態を、BE の ordering に変換する
 * @param sortModel 表の並び替えの状態
 * @returns BE の ordering（並び替えの指定が無い・対象外の列なら既定の並び）
 */
export const toReceptionBookOrdering = (
  sortModel: GridSortModel
): ReceptionBookOrdering => {
  const [item] = sortModel;
  const key = item ? RECEPTION_BOOK_SORT_KEYS[item.field] : undefined;
  if (!item || !key) return DEFAULT_RECEPTION_BOOK_ORDERING;
  return item.sort === "asc" ? key : `-${key}`;
};
